/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CaseRowColumn {
  StatNumberSe = 0,
  StatNumberNo = 1,
  Description = 2,
  GrossWeight = 3,
  NetWeight = 4,
  Price = 5,
  GoodsMarking = 6,
  ChassisNumber = 7,
  PackageCount = 8,
  OriginCountryCode = 9,
  PackageCategoryCode = 10,
  OtherQuantity = 11,
  OriginRegionId = 12,
  ProcedureCode = 13,
  ProcedureAddonCode = 14,
  SePreferenceCode = 15,
  CustomsWarehouse = 16,
  ValueDeterminationCode = 17,
  NoPreferenceCode = 18,
  RowNo = 19,
  OtherQuantityNo = 20,
}
